function normalizedPath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

/**
 * Returns the same-origin API base path used by the new HTTP server runtime.
 */
export function getServerApiBasePath(): string {
  return '/api';
}

/**
 * Builds an absolute API URL in browser environments and a relative path elsewhere.
 */
export function getServerApiUrl(path: string): string {
  const apiPath = `${getServerApiBasePath()}${normalizedPath(path)}`;

  if (typeof window === 'undefined' || !window.location?.origin) {
    return apiPath;
  }

  return new URL(apiPath, window.location.origin).toString();
}
